/* eslint-disable no-console */

declare global {
  interface Window {
    Sentry: {
      captureException: (error: Error) => string;
      captureMessage: (message: string) => void;
      configureScope(
        param: (scope: {
          // eslint-disable-next-line @typescript-eslint/ban-types
          setUser: (user: object) => void;
          setTag(tagName: string, tagValue: number): void;
        }) => void,
      ): void;
    };
  }
}

export function logError(error: Error): void {
  console.error(error);
  window.Sentry?.captureException(error);
}
